import { ChakraTheme } from '@chakra-ui/react'

export const Avatar: ChakraTheme['components']['Avatar'] = {
  sizes: {
    '2xs': {
      container: {
        boxSize: '1rem',
      },
      label: {
        fontSize: '0.5625rem',
      },
    },
  },
}
